import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Checkbox from '@material-ui/core/Checkbox'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.primary,
        backgroundColor: theme.background,
        borderRadius: theme.borderRadius,
        border: theme.border,
        margin: 0,
        width: '100%',
        justifyContent: 'space-between'
    },
    rootLabel: {
        fontSize: 14,
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        padding: 16
    },
    labelWrapper: {
        display: 'flex',
        gap: 8
    },
    labelAndDescriptionWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    labelText: {
        wordBreak: 'break-word'
    },
    labelDescription: {
        wordBreak: 'break-word',
        fontSize: 12,
        fontWeight: 500
    },
    checkboxRoot: {
        color: theme.quaternary
    },
    checkboxChecked({ inverted }) {
        return {
            color: inverted ? 'inherit' : `${theme.primary} !important`
        }
    }
}))

//This component is checkbox with label and description
export default function CustomCheckboxV2(props) {
    const classes = useStyles({ inverted: props.inverted })

    const {
        label,
        icon,
        description,
        onClick,
        checked,
        disabled,
        className,
        customOnClick,
        ...restProps
    } = props

    const CheckBoxLabel = ({ label, icon: Icon, description }) => {
        return (
            <div className={classes.labelWrapper}>
                {Icon && (
                    <div className={classes.iconWrapper}>
                        <Icon />
                    </div>
                )}
                <div className={classes.labelAndDescriptionWrapper}>
                    <div className={classes.labelText}>{label}</div>
                    <div className={classes.labelDescription}>
                        {description}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <FormControlLabel
            className={classNames(classes.root, className)}
            classes={{
                label: classes.rootLabel
            }}
            label={
                <CheckBoxLabel
                    icon={icon}
                    description={description}
                    label={label}
                />
            }
            disabled={disabled}
            labelPlacement="start"
            control={
                <Checkbox
                    classes={{
                        root: classes.checkboxRoot,
                        checked: classes.checkboxChecked
                    }}
                    icon={<CircleUnchecked />}
                    checkedIcon={<CircleCheckedFilled />}
                    onChange={onClick}
                    onClick={customOnClick}
                    checked={checked}
                    disabled={disabled}
                    size="small"
                    {...restProps}
                />
            }
        />
    )
}
